<!--SKU编辑  -->
<template>
	<el-dialog title="字典项目信息" :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="600px">
		<div class="form-box">
			<el-form :model="dataForm" :rules="rules" ref="dataForm" label-width="100px">
				<div class="flex flex-between">
					<el-form-item label="名称" prop="itemName">
						<el-input v-model.trim="dataForm.itemName" maxlength="20"></el-input>
					</el-form-item>
					<el-form-item label="编码" prop="itemCode">
						<el-input v-model.trim="dataForm.itemCode" maxlength="20"></el-input>
					</el-form-item>
				</div>
				<div class="flex flex-between">
					<el-form-item label="值" prop="itemValue">
						<el-input v-model.trim="dataForm.itemValue" maxlength="20"></el-input>
					</el-form-item>
					<el-form-item label="顺序" prop="levelSort">
						<el-input v-model.trim="dataForm.levelSort" maxlength="3"></el-input>
					</el-form-item>
				</div>
				<el-form-item label="备注" prop="remark">
					<el-input v-model.trim="dataForm.remark" type="textarea" :rows="2" maxlength="100"></el-input>
				</el-form-item>
			</el-form>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button size="small" @click="dialogVisible = false">取 消</el-button>
			<el-button size="small" type="primary" @click="handleSubmit">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { debounce } from "@/utils/debounce";
export default {
	data() {
		return {
			dialogVisible: false,
			dataForm: {
				pcodesetId: "",
				codesetName: "",
				codesetCode: "",
				itemName: "",
				itemCode: "",
				itemValue: "",
				levelSort: "",
				remark: "",
			},
			rules: {
				itemName: [
					{
						required: true,
						message: "名称不能为空",
						trigger: "blur",
					},
				],
				itemCode: [
					{
						required: true,
						message: "编码不能为空",
						trigger: "blur",
					},
				],
				levelSort: [
					{
						pattern: /^[0-9]*$/,
						message: "请输入整数",
					},
				],
			},
		};
	},
	created() {},
	methods: {
		init(pdt, dt) {
			this.dialogVisible = true;
			this.$nextTick(() => {
				this.$refs.dataForm.resetFields();
				this.dataForm.codesetName = pdt.codesetName;
				this.dataForm.codesetCode = pdt.codesetCode;
				delete this.dataForm.codesetId;
				// 编辑
				if (dt) {
					this.dataForm.pcodesetId = dt.pcodesetId;
					this.dataForm.codesetId = dt.codesetId;
					this.dataForm.itemName = dt.itemName;
					this.dataForm.itemCode = dt.itemCode;
					this.dataForm.itemValue = dt.itemValue;
					this.dataForm.levelSort = dt.levelSort;
					this.dataForm.remark = dt.remark;
				} 
				// 新增
				else {
					this.dataForm.pcodesetId = pdt.codesetId;
				}
			});
		},
		handleSubmit: debounce(
			function () {
				if (this.dialogVisible == false) {
					return;
				}
				this.$refs["dataForm"].validate((valid) => {
					if (valid) {
						this.$confirm("是否确认保存？", {
							confirmButtonText: "确定",
							cancelButtonText: "取消",
						})
							.then(() => {
								let that = this;
								that.$request.post(that.dataForm.codesetId ? "updateSysCodeSet" : "addSysCodeSet", true, that.dataForm).then((res) => {
									if (res) {
										that.dialogVisible = false;
										that.$emit("getSysCodeSetChildList");
										that.$message.success("保存成功");
									}
								});
							})
							.catch(() => {});
					} else {
						return false;
					}
				});
			},
			1000,
			true,
		),
	},
	beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.mb0 {
	margin-bottom: 0 !important;
}
</style>
